import I18n from 'I18n';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import ObjectTypeSelectionPanel from 'automation-ui-canvas/create/trigger-prompts/ObjectTypeSelectionPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyObjectTypeSelectionPanel(props) {
  return /*#__PURE__*/_jsx(ObjectTypeSelectionPanel, Object.assign({}, props, {
    noneOption: {
      value: UNKNOWN_ID,
      text: I18n.text('createWorkflow.objectTypeSelectionPanel.default.property'),
      hidden: false,
      disabled: false,
      locked: false
    }
  }));
}